import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PAGES_AND_PATHS } from '../../constants/pages-and-paths';
import { DeleteMyDataComponent } from './delete-my-data.component';
import { OuterPagesGuardService } from '../../guards/outer-pages-guard.service';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.deleteMyData.pageInRouting,
    data: { data: PAGES_AND_PATHS.deleteMyData },
    component: DeleteMyDataComponent,
    canActivate: [],
    loadChildren: () => import('./delete-my-data.module').then(m => m.DeleteMyDataModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeleteMyDataRoutingModule { }
